import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import KflCard from "./KflCard"
import classes from "./index.module.scss"

const KfList = (props) => {
  const {
    selectedCategory,
    selectedSubCategory,
    design
  } = props

  const [t] = useTranslation()

  const foodsMap =
    useSelector(state => state.foods)

  const groupedFoodIdsBasedOnCategory =
    useSelector(state => state.groupedFoodIdsBasedOnCategory)

  const categoryName =
    selectedSubCategory?._id ||
    selectedCategory?._id ||
    ""

  const foodIds =
    groupedFoodIdsBasedOnCategory[categoryName]

  if (!foodIds) {
    return (
      <div className={classes["empty"]}>
        {t("هیچ_محصولی_یافت_نشد")}
      </div>
    )
  }

  return (
    <div
      className={classes["container"]}
      style={{
        "--kiosk-grid-mobile-columns": design.productGrid.mobileColumns,
        "--kiosk-grid-tablet-columns": design.productGrid.tabletColumns,
        "--kiosk-grid-desktop-columns": design.productGrid.desktopColumns
      }}
    >
      {foodIds.map(foodId =>
        !!foodsMap[foodId] &&
        <KflCard
          key={foodId}
          food={foodsMap[foodId]}
          design={design}
        />
      )}
    </div>
  )
}

export default KfList
